import styled from 'styled-components';

import { size } from '../layout/helpers';

export const Sticky = styled.div`
  position: relative;
  padding: ${size(2)};
  margin: 0 ${size(-2)};
  z-index: 1;
  border-top: 1px solid rgba(0, 0, 0, 0.05);

  &:before {
    content: '';
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: -1;
    background: white;
  }

  &:after {
    content: '';
    position: absolute;
    transition: transform 125ms ease-in-out;
    z-index: -2;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 50%;
    box-shadow:
      0 0 3px rgba(0, 0, 0, 0.05),
      0 0 15px rgba(0, 0, 0, 0.1);
  }

  &.locked {
    position: fixed;
    width: 100%;
    bottom: 0;
    left: 0;
    margin: 0;
    border-top-color: transparent;

    &:after {
      transform: translateY(-100%);
    }
  }
`;
